import isEmpty from 'lodash/isEmpty'
import { FC } from 'react'

import ExportSchedulingContainer from 'src/components/data/containers/ExportSchedulingContainer'
import useComponentConfig from 'src/hooks/useComponentConfig'
import { ExportConfig } from 'src/utils/export'

interface PageHeaderExportDashboardProps {
  exportDashboardComponentCode: string
  isOpen: boolean
  onClose: () => void
}

const ModalExportDashboard: FC<PageHeaderExportDashboardProps> = ({
  exportDashboardComponentCode,
  isOpen,
  onClose,
}) => {
  const exportDashboardConfig: ExportConfig = useComponentConfig(exportDashboardComponentCode)

  if (isEmpty(exportDashboardConfig)) {
    return null
  }

  return (
    <ExportSchedulingContainer
      exportDashboardConfig={exportDashboardConfig as ExportConfig}
      isOpen={isOpen}
      onClose={onClose}
    />
  )
}

export default ModalExportDashboard
